<!--
Workaround for mangel med checkboxgruppe
Checkboxgruppe er ikke designet for å bli brukt slik vi bruker den (i KartleggingService)
så "tvinger" Angular til å ødelegge og lage komponenten på nytt
-->
@for (f of [form()]; track f) {
    <hb-felt-checkboxgruppe
        aria-live="assertive"
        [legendText]="legendText"
        [control]="f.controls.control"
        [alternativer]="alternatives()"
    />
}
